module.exports = __webpack_public_path__ + "static/directory_3-83f1da8be364f4b6f435eec8a0126591.png";